import { isNullOrUndefined } from "@app/shared/utility/isNullOrUndefined";

export const formatAccuracyBandPercent = (percent: number | null | undefined): string => {
  if (isNullOrUndefined(percent)) {
    return "---";
  }

  if (percent > 0 && percent < 1) {
    return "<1%";
  }

  return `${Math.round(percent)}%`;
};
